import { DossierMember } from './DossierMember';

export interface IDossierV2 {
  id: number;
  name: string;
  archived: boolean;
  createdAt: Date|string;
  lastActivityAt: Date|string;
}

export interface IDossierWithOptionalRelation {
  dossier: DossierV2;
  relation?: DossierMember;
  dossierRelations: DossierMember[];
}

export interface IDossierWithRelation {
  dossier: DossierV2;
  relation: DossierMember;
  dossierRelations: DossierMember[];
}

export class DossierV2 implements IDossierV2 {
  readonly id: number;
  readonly name: string;
  readonly archived: boolean;
  readonly createdAt: Date;
  readonly lastActivityAt: Date;

  constructor({ id, name, archived, createdAt, lastActivityAt }: IDossierV2) {
    this.id = id;
    this.name = name;
    this.archived = archived;
    this.createdAt = new Date(createdAt);
    this.lastActivityAt = new Date(lastActivityAt);
  }

  match(compare: DossierV2): boolean {
    return this.id === compare.id;
  }

  getFormattedCreatedAt(): string {
    return `${this.dateToDay(this.createdAt)} ${this.dateToTime(this.createdAt)}`;
  }

  getFormattedLastActivityAt(): string {
    return `${this.dateToDay(this.lastActivityAt)} ${this.dateToTime(this.lastActivityAt)}`;
  }

  private dateToTime(date: Date): string {
    return date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
  }

  private dateToDay(date: Date): string {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('nl-NL', options);
  }
}
